<script>

export default {
  name: 'ProgramMixin',
  data() {
    return {
      dateFormatter: new Intl.DateTimeFormat('default', {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      }),
    }
  },
  methods: {
    parseDate(isoDate) {
      // A plain date (YYYY-MM-DD), as a local date rather than UTC midnight
      const [year, month, day] = isoDate.split('-').map(Number);
      return new Date(year, month - 1, day);
    },
    weekCount(program) {
      // Workouts without a week (null) don't count
      return program.workouts.reduce((weeks, item) => Math.max(weeks, item.week || 0), 0);
    },
    workoutCount(program) {
      // A workout may be assigned to several weeks
      return new Set(program.workouts.map(item => item.workoutUuid)).size;
    },
  }
}
</script>
